export default "__VITE_ASSET__HaMsEAmADyd6XFhvlHqbmw__"